/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityDomainsDNSResult } from './MonitEntityDomainsDNSResult';
import {
    MonitEntityDomainsDNSResultFromJSON,
    MonitEntityDomainsDNSResultFromJSONTyped,
    MonitEntityDomainsDNSResultToJSON,
} from './MonitEntityDomainsDNSResult';

/**
 * 
 * @export
 * @interface MonitEntityDomainsDNSAggResponse
 */
export interface MonitEntityDomainsDNSAggResponse {
    /**
     * 
     * @type {Array<MonitEntityDomainsDNSResult>}
     * @memberof MonitEntityDomainsDNSAggResponse
     */
    results?: Array<MonitEntityDomainsDNSResult>;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDomainsDNSAggResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the MonitEntityDomainsDNSAggResponse interface.
 */
export function instanceOfMonitEntityDomainsDNSAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityDomainsDNSAggResponseFromJSON(json: any): MonitEntityDomainsDNSAggResponse {
    return MonitEntityDomainsDNSAggResponseFromJSONTyped(json, false);
}

export function MonitEntityDomainsDNSAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityDomainsDNSAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityDomainsDNSResultFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function MonitEntityDomainsDNSAggResponseToJSON(value?: MonitEntityDomainsDNSAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityDomainsDNSResultToJSON)),
        'total': value.total,
    };
}

